<template>
<div class="pricing-plan">
    <div class="plan-description">
        <div v-for="copy in final_copy">
            <h6>{{copy.header_name | removeUnderScores }}</h6>
                <p v-html="copy.value"></p>
        </div>
    </div>
</div>
</template>

<script>
export default {
  props: ['product'],
  data: function () {
    return {
      final_copy: []
    }
  },
  mounted: function () {
    this.mapValuetoHeader(this.product.copy_header, this.product.latest_ch_val)
  },
  methods: {
    mapValuetoHeader: function (headers, header_values) {
      var self = this

      self.final_copy = headers.map((val, i, headers) => {
        return val
      })

      self.final_copy.map(x =>
        Object.assign(x, header_values.find(y => y.header_id == x.id))
      )
    }
  },
  watch: {
    product () {
      this.final_copy = this.mapValuetoHeader(this.product.copy_header, this.product.latest_ch_val)
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().replace('_', ' ')
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    removeUnderScores: function (value) {
      if (!value) return ''
      return value.toString().replace('_', ' ')
    }
  }
}
</script>

<style scoped>
.pricing-plan, .pricing-plan .plan-body {
    background-color: #f2f4f8;
}
.plan-description {
    background-color: #f2f4f8;
    padding: 10px;
}

</style>
